import React, {Fragment} from 'react';
import Box from '../layout/Box';
import classNames from 'classnames';
import Button from "../form/Button";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import DateTimeInput from "../form/DateTimeInput";
import moment from "moment";
import EmailTemplateEditor from "./EmailTemplateEditor";
import {paramsSerializer, postData} from "../../utils/request";
import createEditor from "../form/ComponentEditor";
import {EmailFormatter} from "../../utils/formatters";
import urldecode from "locutus/php/url/urldecode";
import {Link} from "react-router-dom";
import Icon from "../form/Icon";
import ConsignmentReportList from "./lists/ConsignmentReportList";
import BoxEditor from "./BoxEditor";
import ConsignmentReportForm from "./forms/ConsignmentReportForm";
import {isEqual} from "lodash-es";

const sortable = true;
const filterable = true;

class Filter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            from: this.props.from,
            to: this.props.to
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const state = {};
        if (this.props.from !== prevProps.from && this.state.from === prevState.from) {
            state.from = this.props.from;
        }
        if (this.props.to !== prevProps.to && this.state.to === prevState.to) {
            state.to = this.props.to;
        }
        if (Object.keys(state).length) {
            this.setState(state);
        }
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-3">
                    <div className="form-group">
                        <DateTimeInput
                            maxDate={this.state.to}
                            value={this.state.from}
                            label="Időszak"
                            saveChanges={(field, from) => this.setState({from})}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group">
                        <DateTimeInput
                            minDate={this.state.from}
                            value={this.state.to}
                            label="&nbsp;"
                            saveChanges={(field, to) => this.setState({to})}
                        />
                    </div>
                </div>
                <div className="col-md-2">
                    <label className="control-label">&nbsp;</label>
                    <Button
                        color={isEqual({from: this.state.from, to: this.state.to}, {from: this.props.from, to: this.props.to}) ? "default" : "warning"}
                        disabled={isEqual({from: this.state.from, to: this.state.to}, {from: this.props.from, to: this.props.to})}
                        block={true}
                        icon={{lib: "fa", name: "search"}}
                        onClick={() => {
                            this.props.onFilter({from: this.state.from, to: this.state.to});
                        }}
                    >
                        Szűrés
                    </Button>
                </div>
            </div>
        );
    }
}

export class ConsignmentReportEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
            <List
                {...this.props}
                collapsed={this.props.collapsed || false}
                theme="default"
                header={"Szállítási címek"}
                footer={[
                    <Button
                        key="0"
                        disabled={this.props.isLoading}
                        color="default"
                        onClick={this.pristineForm}
                    >
                        Új
                    </Button>
                ]}
            >
                <ConsignmentReportList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
            </List>
            <Editor
                {...this.props}
                ref={(editor) => this.editor = editor}
                theme="default"
                header={this.state.editorHeader}
                footer={[
                    <Button
                        key="0"
                        disabled={!this.props.dirty || this.props.isLoading}
                        color="primary"
                        className="pull-right"
                        onClick={this.saveForm}
                    >
                        Mentés
                    </Button>
                ]}
            >
                <ConsignmentReportForm {...this.props} />
            </Editor>
        </Fragment>;
    }
}

class ConsignmentReportGenerator extends React.Component {

    state = {
        from: moment().subtract(1, "months").startOf('month').format("YYYY-MM-DD"),
        to: moment().subtract(1, "months").endOf('month').format("YYYY-MM-DD")
    }

    render() {
        const startdate = this.state.from + " 00:00:00";
        const enddate = this.state.to + " 23:59:59";
        return <Fragment>
            <Box
                footer={
                    <Button
                        color="primary"
                        className="pull-right"
                        icon={{lib: "fa", name: "paper-plane"}}
                        disabled={this.props.isLoading}
                        onClick={() => {
                            this.props.processAction(async () => {
                                return await postData({
                                    action: 'ConsignmentReport.bulkSend',
                                });
                            });
                        }}
                    >
                        Összes küldése
                    </Button>
                }
            >
                <ConsignmentReportList {...this.props} selection={null} loadForm={() => {}} actions={true} />
            </Box>
            <Box>
                <Filter
                    from={this.state.from}
                    to={this.state.to}
                    onFilter={({from, to}) => {
                        this.setState({from, to});
                    }}
                />
                <SelectorGrid
                    ref={(consignorList) => this.consignorList = consignorList}
                    className={"p-small-table"}
                    component="Consignor"
                    pageSize={50}
                    loading={this.props.isLoading}
                    reqparams={{exact: true}}
                    filter={[{field: "close_date", value: [startdate, enddate], operator: "between"},{field: "report_exists", value: 0}]}
                    onLoadCompleted={(response) => {
                        response = {...response};
                        response.aggregations = [{}];
                        return response;
                    }}
                    columns={{
                        "action.view": {
                            header: " ",
                            renderer: (v, rowData) => {
                                return (
                                    <Link
                                        class="btn btn-default btn-xs btn-block"
                                        to={"?" + urldecode(paramsSerializer({option: "partner", partner_id: rowData.consignor_id}))}
                                    >
                                        <Icon lib="fas" name="pencil-alt"/>
                                    </Link>
                                );
                            }
                        },
                        "name": {
                            header: "Név",
                            sortable,
                            filterable,
                        },
                        "email": {
                            header: "Email",
                            sortable,
                            filterable,
                            renderer: EmailFormatter
                        },
                        "action.send": {
                            header: " ",
                            renderer: (v, rowData) => {
                                return (
                                    <Button
                                        block={true}
                                        color="default"
                                        size="xs"
                                        icon={{lib: "fas", name: "shapes"}}
                                        disabled={this.props.isLoading}
                                        onClick={() => {
                                            this.props.processAction(async () => {
                                                const res = await postData({
                                                    action: 'ConsignmentReport.create',
                                                    data: {
                                                        consignor: rowData.consignor_id,
                                                        startdate,
                                                        enddate,
                                                    }
                                                });
                                                this.consignorList && this.consignorList.refreshBackground();
                                                return res;
                                            });
                                        }}
                                    >
                                        Generálás
                                    </Button>
                                );
                            },
                            aggregation: () => {
                                return (
                                    <Button
                                        block={true}
                                        color="primary"
                                        size="xs"
                                        icon={{lib: "fas", name: "shapes"}}
                                        disabled={this.props.isLoading}
                                        onClick={() => {
                                            this.props.processAction(async () => {
                                                const res = await postData({
                                                    action: 'ConsignmentReport.bulkCreate',
                                                    startdate,
                                                    enddate,
                                                });
                                                this.consignorList && this.consignorList.refreshBackground();
                                                return res;
                                            });
                                        }}
                                    >
                                        Generálás
                                    </Button>
                                );
                            }
                        },
                        "action.preview": {
                            header: " ",
                            renderer: (v, rowData) => {
                                return (
                                    <Button
                                        block={true}
                                        color="default"
                                        size="xs"
                                        icon={{lib: "fas", name: "eye"}}
                                        disabled={this.props.isLoading}
                                        onClick={() => {
                                            this.props.processAction(async () => {
                                                return await postData({
                                                    action: 'ConsignmentReport.preview',
                                                    data: {
                                                        consignor: rowData.consignor_id,
                                                        startdate,
                                                        enddate,
                                                    }
                                                });
                                            });
                                        }}
                                    >
                                        Előnézet
                                    </Button>
                                );
                            }
                        },
                    }}
                    orderBy={{field: "name", direction: "ASC"}}
                />
            </Box>
            <EmailTemplateEditor
                filter={[{field: "token", value: "ConsignmentReportEmail"}]}
                fieldForm="ConsignmentReportEmail"
                editorContext={"ConsignmentReportEmailTemplate"}
            />
        </Fragment>;
    }
}

export default createEditor({componentName: "ConsignmentReport", WrappedComponent: ConsignmentReportGenerator});
